import * as types from './TagsTypes';

//Tag list
export const actionTagListRequest = () => ({
  type: types.TAG_LIST_REQUEST,
});

export const actionTagListSuccess = (payload) => ({
  type: types.TAG_LIST_SUCCESS,
  payload,
});

export const actionTagListFail = (payload) => ({
  type: types.TAG_LIST_FAIL,
  payload,
});
